import { Component, Output, Input, ChangeDetectorRef, EventEmitter, ViewChild } from '@angular/core';
import { SpeechRecognition } from '@ionic-native/speech-recognition';
import { FilePath } from '@ionic-native/file-path';

@Component({
  selector: 'input-mensagem',
  templateUrl: 'input-mensagem.html'
})
export class InputMensagemComponent {

  @ViewChild('input') textarea: any;
  @Input() placeHolder: string;
  @Output() enviarImagem: EventEmitter<File>;
  @Output() enviarArquivo: EventEmitter<File>;
  @Output() enviarMensagem: EventEmitter<string>;
  @Output() inputFocus: EventEmitter<void>;
  public mensagem: string;

  constructor(private speechRecognition: SpeechRecognition,
    private changeDetector: ChangeDetectorRef,
    private filePath: FilePath) {
    this.mensagem = "";
    this.placeHolder = "Mensagem...";
    this.enviarMensagem = new EventEmitter<string>();
    this.enviarArquivo = new EventEmitter<File>();
    this.enviarImagem = new EventEmitter<File>();
    this.inputFocus = new EventEmitter<void>();
  }

  public teste(event: any) {
    if (event.srcElement.files.length <= 0) {
      return;
    }
    const file = event.srcElement.files[0];
    const type = file.type;
    if (type == "image/png" || type == "image/jpeg" || type == "image/jpg") {
      this.enviarImagem.emit(file);
    } else if (type == "application/pdf") {
      this.enviarArquivo.emit(file);
    } else {

    }
    // retorna ao valor inicial para o listener change ser ativado quando escolher o mesmo arquivo
    // duas vezes em seguida
    event.srcElement.value = "";
  }

  public emitirFoco(): void {
    this.inputFocus.emit();
  }

  public enviar(): void {
    const mensagemEnvio = this.mensagem;
    this.textarea.value = "";
    this.mensagem = "";
    this.enviarMensagem.emit(mensagemEnvio);
  }

  public preventFocusChange(e: any) {
    e.preventDefault();
    //e.stopPropagation();
  }

  private detectChanges() {
    try {
      this.changeDetector.detectChanges();
    }catch(e) {};
  }

  private pedirPermisaoAudio(): Promise<void> {
    return new Promise((resolve, reject)=> {
      this.speechRecognition.hasPermission().then(
        (permition) => {
          if (!permition) {
            this.speechRecognition.requestPermission().then(
              () => {
                resolve();
              }, ()=> {
                reject();
              }
            )
          } else {
            resolve();
          }
        }
      )
    });
  }

  public gravarAudio(): void {
    this.pedirPermisaoAudio().then(
      () => {
        this.speechRecognition.startListening({language: 'pt-BR'}).subscribe(
          (matches: Array<string>) => {
            this.mensagem = matches[0];
          },  
          (error) => {
            console.log(error);
          }
        )
      }, () => {}
    )
  }

  public isMensagemEmpty(): boolean {
    return !this.mensagem || !(this.mensagem.length > 0);
  }

  public deveApresentarIcone(): boolean {
    return this.mensagem === '';
  }
}



// WEBPACK FOOTER //
// ./src/components/input-mensagem/input-mensagem.ts